import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=36a90a1a&scoped=true"
import script from "./Role.vue?vue&type=script&lang=js"
export * from "./Role.vue?vue&type=script&lang=js"
import style0 from "./Role.vue?vue&type=style&index=0&id=36a90a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a90a1a",
  null
  
)

export default component.exports